var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimeStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1397 7.21285C14.969 7.31154 14.969 8.51496 14.1397 8.61366L9.2692 9.19329C8.94525 9.23184 8.69001 9.48752 8.65201 9.81153L8.0814 14.677C7.98395 15.5079 6.77776 15.5079 6.68031 14.677L6.1097 9.81153C6.0717 9.48752 5.81646 9.23184 5.49251 9.19329L0.621995 8.61366C-0.207332 8.51496 -0.207332 7.31154 0.621996 7.21285L5.4925 6.63327C5.81645 6.59472 6.0717 6.33904 6.1097 6.01502L6.68031 1.14956C6.77776 0.31864 7.98395 0.318636 8.0814 1.14955L8.65201 6.01502C8.69001 6.33904 8.94525 6.59472 9.2692 6.63327L14.1397 7.21285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeStar);
export default __webpack_public_path__ + "static/media/prime-star.bd56153c5fd1574d355a1dd09bce7159.svg";
export { ForwardRef as ReactComponent };